const styles = theme => ({
  container: {
    height: 'calc(100vh - 60px)', 
    width: '100vw',
  },
});

export default styles;